<template>
    <transition type="animation" appear enter-active-class="animate__animated animate__fadeIn" mode="out-in">
        <div v-if="temPermissao('p-super-admin')" class="admin-superpro">
            <div class="mb-2 p-2 border-bottom border-light">
                <h5 class="font-weight-light">
                    <i class="fa-light fa-magnifying-glass-dollar"></i>
                    Consultar Crédito
                </h5>
            </div>
            <Loading v-if="isLoading" class="loading" loadingText="Carregando..." />
            <b-form v-else>
                <b-form-row v-if="consulta_credito.length == 0">
                    <b-col cols="12" md="6" lg="4" class="mt-4 mt-lg-3 form-group">
                        <label for="input-idUser">ID do Usuário: <span class="text-danger">*</span></label>
                        <b-input-group>
                            <b-form-input size="sm" type="text" placeholder="ID"
                                v-model.trim="tempIdUsuario"></b-form-input>
                            <b-input-group-append class="append">
                                <i class="fa-regular fa-user"></i>
                            </b-input-group-append>
                        </b-input-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4"
                        class="mt-2 mt-md-4 mt-lg-3 d-flex align-items-center justify-content-center justify-content-md-start">
                        <b-button class="shadow-none btn-primary border-primary w-auto"
                            @click="pos_consulta_credito">Confirmar</b-button>
                    </b-col>
                </b-form-row>
                <b-form-row v-else>
                    <b-col cols="12" md="6" lg="4" class="mt-4 mt-lg-3 form-group">
                        <label for="input-idUser">ID do Usuário: <span class="text-danger">*</span></label>
                        <b-input-group>
                            <b-form-input size="sm" type="text" placeholder="ID"
                                v-model.trim="tempIdUsuario"></b-form-input>
                            <b-input-group-append class="append">
                                <i class="fa-regular fa-user"></i>
                            </b-input-group-append>
                        </b-input-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4"
                        class="mt-2 mt-md-4 mt-lg-3 d-flex align-items-center justify-content-center justify-content-md-start">
                        <b-button class="shadow-none btn-primary border-primary w-auto"
                            @click="pos_consulta_credito">Confirmar</b-button>
                    </b-col>
                    <b-col cols="12" md="12" class="mt-4">
                        <Loading v-if="isLoading" class="loading" />
                        <div v-else>
                            <div v-if="idUsuario == ''">
                                <h5 class="mt-4 text-center">O campo ID do Usuário é obrigatório!</h5>
                            </div>
                            <b-table v-else size="lg" :items="formattedData" :fields="fields" class="custom-table mt-4">
                                <template #cell(id)="row">
                                    {{ row.item.idUsuario }}
                                </template>
                                <template #cell(balance)="row">
                                    R$ {{ row.item.saldo | formatPrice }}
                                </template>
                                <template #cell(expiration)="row">
                                    {{ row.item.vencimento | formatShortDate }}
                                </template>

                                <template #cell(activated)="row">
                                    <i :class="row.item.status == true ? 'fa-sharp fa-solid fa-circle fa-xs text-success' : 'fa-sharp fa-solid fa-circle fa-xs text-danger'"
                                        v-b-tooltip.hover.right
                                        :title="row.item.status == true ? 'Ativo' : 'Desativado'"></i>
                                </template>
                                <template #cell(error)="row">
                                    <i :class="row.item.erro == '0' ? 'fa-sharp fa-solid fa-circle fa-xs text-secondary' : 'fa-sharp fa-solid fa-circle fa-xs text-danger'"
                                        v-b-tooltip.hover.left
                                        :title="row.item.erro == '0' ? 'Sem erros' : 'Com erros'"></i>
                                </template>
                            </b-table>
                        </div>
                    </b-col>
                </b-form-row>
            </b-form>
        </div>
        <div v-else>
            <div class="container">
                <div class="text-center">
                    {{ error503 }}
                    <p>Você não tem permissão para visualizar este conteúdo.</p>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import ApiService from '../../../../../common/api.service';
export default {
    components: { Loading: () => import('@/components/loading.vue') },
    data() {
        return {
            isLoading: false,
            spiner: false,
            consulta_credito: [], //289439 Funcão com Falha ticket aberto no superpro:  20240627000001  
            idUsuario: '',
            senha: '',

            tempIdUsuario: '',

            fields: [
                { key: 'id', label: 'ID do Usuário', class: 'text-center font-weight-light' },
                { key: 'balance', label: 'Saldo', class: 'text-center font-weight-light' },
                { key: 'expiration', label: 'Vencimento', class: 'text-center font-weight-light' },
                { key: 'activated', label: 'Status', class: 'text-center font-weight-light' },
                { key: 'error', label: 'Erro', class: 'text-center font-weight-light' },
            ],
        };
    },
    async mounted() {
        if (this.$route.query.loading) {
            this.isLoading = true;
            try {
                await this.fetchData();
            } catch (error) {
                console.error("ERROR loading data: ", error)
            } finally {
                this.isLoading = false
            }
        }
    },

    methods: {
        async fetchData() {
            await new Promise((resolve) => setTimeout(resolve, 1000))
        },
        temPermissao(permissao) {
            return this.permissions.includes(permissao);
        },
        pos_consulta_credito() {
            this.isLoading = true;
            this.idUsuario = this.tempIdUsuario;

            this.spiner = true;
            ApiService.get('v1/saldo-usuario', {
                idUsuario: this.idUsuario,

            })
                .then((response) => {
                    this.consulta_credito = response;
                })
                .catch(function (error) {
                    console.log(error);
                })
                .finally(() => {
                    setTimeout(() => {
                        this.isLoading = false;
                    }, 3000);
                });
        },
    },
    computed: {
        permissions() {
            return this.$store.state.auth.userpermissions.permissions;
        },
        error503() {
            return (window.location.href = '/nao-autorizado');
        },
        formattedData() {
            if (!this.consulta_credito.data || !this.consulta_credito.data.credito_usuario) {
                return [];
            }

            const creditoUsuario = this.consulta_credito.data.credito_usuario;

            if (creditoUsuario && typeof creditoUsuario === 'object') {
                return [{
                    idUsuario: this.idUsuario,
                    saldo: creditoUsuario.xml?.dados?.saldo,
                    vencimento: creditoUsuario.xml?.dados?.vencimento || '-',
                    status: creditoUsuario.status,
                    erro: creditoUsuario.erro,
                }];
            }

            console.log('Dados formatados: ', data)
            return [];
        },
    },
};
</script>

<style scoped>
.fade-in-up {
    -webkit-animation: fadeIn 0.4s ease-in-out;
    -moz-animation: fadeIn 0.4s ease-in-out;
    -o-animation: fadeIn 0.4s ease-in-out;
    animation: fadeIn 0.4s ease-in-out;
}

.loading {
    height: 25vh;
}
</style>
